module fdm.clientManagement {

    angular.module('fdm.clientManagement')
        .config(['$stateProvider', '$locationProvider',
            ($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {

                dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .state('app.clientDetails', {
                        url: 'client-management',
                        apiUrl: 'client',
                        templateUrl: '/app/src/client-management/client-management-screen.html'
                    })
            }]);

}